//
//
//
//
//
//
//

import { mapGetters } from "vuex";

export default {
	name: "Loader",
	data() {
		return {
			
		};
	},
	computed: {
		...mapGetters([
			
		]),
	},
	methods: {
		
	},
	created() {
		
	},
};
